// @flow

import _ from 'lodash';

import type {
  ProductVisibilityState,
  ProductVisibilityAction
} from 'stores/flow-type/product-visibility.type';

import {
  GET_PRODUCT_VISIBILITY_RULES_REQUEST,
  GET_PRODUCT_VISIBILITY_RULES_SUCCESS,
  GET_PRODUCT_VISIBILITY_RULES_FAILURE,
  UPDATE_PRODUCT_VISIBILITY_RULES_REQUEST,
  UPDATE_PRODUCT_VISIBILITY_RULES_SUCCESS,
  UPDATE_PRODUCT_VISIBILITY_RULES_FAILURE
} from 'stores/flow-type/product-visibility.type';

const initialState: ProductVisibilityState = {
  loading: false,
  saving: false,
  deleting: false,
  reordering: false,

  success: false,
  error: null,
  productVisibilityRules: [],
  total: 0
};

const productVisibilityReducers = (
  state: ProductVisibilityState = initialState,
  action: ProductVisibilityAction
) => {
  switch (action.type) {
    // Get product visibility rules
    case GET_PRODUCT_VISIBILITY_RULES_REQUEST:
      return {
        ...state,
        success: false,
        loading: true,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case GET_PRODUCT_VISIBILITY_RULES_SUCCESS: {
      const { data } = action.payload;
      let { data: productVisibilityRules, total } = data;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        productVisibilityRules,
        total
      };
    }
    case GET_PRODUCT_VISIBILITY_RULES_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    // Update product visibility rules
    case UPDATE_PRODUCT_VISIBILITY_RULES_REQUEST:
      return {
        ...state,
        success: false,
        saving: true
      };
    case UPDATE_PRODUCT_VISIBILITY_RULES_SUCCESS: {
      const { data } = action.payload;
      const { data: productVisibilityRules, total } = _.pick(data, ['data', 'total']);

      // Save updated product visibility rule to store
      return {
        ...state,
        saving: false,
        success: true,
        productVisibilityRules,
        total,
        error: undefined
      };
    }
    case UPDATE_PRODUCT_VISIBILITY_RULES_FAILURE:
      return {
        ...state,
        saving: false,
        success: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default productVisibilityReducers;
